import { Action, createReducer, Store } from "ngrx-actions";

import { EdcMachine } from "@tendercuts/models/store/edc-machine";
import {
  ActionLoadStoreConfig,
  ActionLoadStores,
  ActionSetCurrentStore,
  ActionSetCurrentStoreEdcMachines,
  ActionStoresLoadEdcMachinesFailed,
  ActionStoresLoadEdcMachinesSuccess,
  ActionLoadStoreConfigSuccess,
  ActionStoresLoadFailed,
  ActionStoresLoadSuccess,
  ActionUpdateSelectedEdcMachine,
} from "./store-state-actions";
import { storeInitialState, StoreState } from "./state";

@Store({ ...storeInitialState })
export class StoreReducers {
  /**
   * set loading flag to true
   * @param { StoreState } state
   * @returns {{ store: Store; loading: boolean; error: boolean; errorMessage: string }}
   */
  @Action(ActionLoadStores)
  actionLoadStores(state: StoreState) {
    return {
      ...state,
      loading: true,
    };
  }

  /**
   * Set all loaded stores to redux cart
   * @param { StoreState } state
   * @param { ActionStoresLoadSuccess } action
   * @returns {{ store: Store; loading: boolean; error: boolean; availableStores: [] }}
   */
  @Action(ActionStoresLoadSuccess)
  actionStoresLoadSuccess(state: StoreState, action: ActionStoresLoadSuccess) {
    return {
      ...state,
      availableStores: action.stores,
      loading: false,
    };
  }

  /**
   * get current store to redux state
   * @param { StoreState } state
   * @param { ActionSetCurrentStore } action
   * @returns {{ store: Store; loading: boolean; error: boolean; errorMessage: string }}
   */
  @Action(ActionSetCurrentStore)
  actionSetStore(state: StoreState, action: ActionSetCurrentStore) {
    return {
      ...state,
      storageLoading: false,
      store: action.store,
    };
  }


  /**
   * Set all loaded edc machines to redux
   * @param { StoreState } state
   * @param { ActionStoresLoadEdcMachinesSuccess } action
   * @returns {{ store: Store; loading: boolean; error: boolean; errorMessage: string }}
   */
   @Action(ActionStoresLoadEdcMachinesSuccess)
   ActionStoresLoadEdcMachinesSuccess(state: StoreState, action: ActionStoresLoadEdcMachinesSuccess) {
     return {
       ...state,
       loading: false,
       error: false
     };
   }


  /**
   * get current store edc machines to redux state
   * @param { StoreState } state
   * @param { ActionSetCurrentStore } action
   * @returns {{ store: Store; loading: boolean; error: boolean; errorMessage: string }}
   */
  @Action(ActionSetCurrentStoreEdcMachines)
  actionSetStoreEdcMachines(state: StoreState, action: ActionSetCurrentStoreEdcMachines) {
    state.store.edcMachines = action.edcMachines;
    return {
      ...state,
      storageLoading: false,
      error: false
    };
  }

  /**
   * Clear the store state.
   * @param { StoreState } state
   * @param { ActionStoresLoadFailed } action
   * @returns {{ store: Store; loading: boolean; error: boolean; errorMsg: string }}
   */
  @Action(ActionStoresLoadFailed)
  actionStoresLoadFailed(state: StoreState, action: ActionStoresLoadFailed) {
    return {
      ...state,
      loading: false,
      error: true,
      errorMsg: action.error,
    };
  }

  /**
   * set error message if load edc machines failed
   * @param { StoreState } state
   * @param { ActionStoresLoadEdcMachinesFailed } action
   * @returns {{ store: Store; loading: boolean; error: boolean; errorMsg: string }}
   */
  @Action(ActionStoresLoadEdcMachinesFailed)
  ActionStoresLoadEdcMachinesFailed(state: StoreState, action: ActionStoresLoadEdcMachinesFailed) {
    return {
      ...state,
      loading: false,
      error: true,
      errorMsg: action.error,
    };
  }

  /**
  * update plutos reference id
  * @param state
  * @param action
  * @returns {{ store: Store; loading: boolean; error: boolean; errorMsg: string }}
  */
  @Action(ActionUpdateSelectedEdcMachine)
  actionUpdateSelectedEdcMachine(state: StoreState, action: ActionUpdateSelectedEdcMachine) {
    state.store.selectedEdcMachine = action.selectedEdcMachine;
    return {
      ...state,
      loading: false,
      error: false,
    };
  }

  /**
   * set loading flag to true
   * @param { StoreState } state
   * @returns {{ store: Store; loading: boolean; error: boolean; errorMessage: string }}
   */
     @Action(ActionLoadStoreConfig)
     ActionLoadStoreConfig(state: StoreState) {
       return {
         ...state,
         configLoading: true,
        };
     }
     
  /**
   * Set all store config to redux 
   * @param { StoreState } state
   * @param { ActionLoadStoreConfigSuccess } action
   * @returns {{ store: Store; loading: boolean;}}
   */
   @Action(ActionLoadStoreConfigSuccess)
   ActionLoadStoreConfigSuccess(state: StoreState, action: ActionLoadStoreConfigSuccess) {
    state.store.storeConfig = action.storeConfig;
    return {
      ...state,
      configLoading: false,
    };
   }

}

export const storeReducer = createReducer(StoreReducers);
